<template>
  <draggable
    v-model="draggableList"
    :disabled="!allows_crud && can_update"
    tag="b-tbody"
    handle=".handle"
  >
    <template v-if="draggableList.length > 0">
      <b-tr v-for="evaluation in draggableList" :key="evaluation.id">
        <b-td
          class="text-center handle"
          :class="{ grabbable: allows_crud }"
          v-if="allows_crud && can_update"
        >
          <b-icon v-if="allows_crud" icon="arrows-expand" scale="1.2"></b-icon>
        </b-td>
        <b-td class="text-center print-nombre">
          <span
            v-if="canOpenRow(evaluation)"
            class="div-href"
            @click="openRow(evaluation)"
          >
            {{ evaluation.name }}
          </span>
          <span v-else>
            {{ evaluation.name }}
          </span>
        </b-td>
        <b-td
          v-if="
            institution.kl_assessment ||
            (institution && institution.internal_use_id == 'duoc.cl')
          "
          class="print-instrumento"
        >
          <div
            v-for="(test, index) in filterTestsByEvaluation(
              evaluation.evaluation
            )"
            class="text-left ml-1"
            :key="test.id"
          >
            <template
              v-if="institution && institution.internal_use_id != 'duoc.cl'"
            >
              -<span
                v-if="
                  canRedirectToEvaluation &&
                  user &&
                  ((!user.group_names.includes('PROFESORES') &&
                    !user.group_names.includes('ESTUDIANTES')) ||
                    user.is_superuser)
                "
                class="div-href"
                @click="redirectToEvaluation(evaluation.evaluation, test.id)"
              >
                {{ test.title }}
              </span>
              <span v-else>
                {{ test.title }}
              </span>
            </template>
            <template v-else
              >{{
                $getVisibleNames(
                  "teaching.evaluationsituation",
                  false,
                  "Situación Evaluativa"
                )
              }}
              {{ index + 1 }}: {{ getWorkType(test.work_type) }} -
              {{ test.weighing }}%
            </template>
          </div>
          <div
            v-if="filterTestsByEvaluation(evaluation.evaluation).length == 0"
            class="text-center"
          >
            {{ $t("reusable.common.notApplicable") }}
          </div>
        </b-td>
        <b-td
          v-if="institution && institution.internal_use_id == 'duoc.cl'"
          style="width: 20%; min-width: 300px"
          class="print-descripcion"
        >
          <div class="description-evaluation">
            <RenderVHtml :content="evaluation.description"></RenderVHtml>
          </div>
        </b-td>
        <b-td class="text-center print-tipo">
          {{
            epm_evaluation_types.find((x) => x.id == evaluation.type)
              ? epm_evaluation_types.find((x) => x.id == evaluation.type).value
              : $t("reusable.common.notApplicable")
          }}</b-td
        >
        <b-td class="text-center print-ponderacion">
          <span v-if="evaluation.type == 5 && institution && institution.apply_transversal_exam_calculation">-</span>
          <!-- Las Actividades del Diseno Instruccional si muestran su ponderacion:
               la Formativa vale 0 y la Sumativa su %. Esa distincion es un
               subtipo y no se lee en la columna Tipo, que para todas dice
               "Actividad". Las actividades creadas desde el Programa, que no
               ponderan, siguen mostrando el guion. -->
          <span v-else-if="evaluation.type == 4 && !isInstructionalActivity(evaluation)">-</span>
          <span v-else> {{ evaluation.weighing }}% </span>
        </b-td>
        <b-td
          v-if="show_evaluation_content && canViewEvaluations"
          class="text-center print-contenido"
        >
          <b-badge
            v-if="evaluationStatus(evaluation).applies"
            :variant="
              evaluationStatus(evaluation).has_content ? 'success' : 'danger'
            "
            v-b-tooltip.v-secondary.noninteractive.top="
              evaluationStatus(evaluation).has_content
                ? $t('matterProgram.matterProgramView.evaluationHasContent', {
                    entity1: $getVisibleNames(
                      'evaluations2.evaluation',
                      false,
                      'Evaluación'
                    ),
                    entity2: $getVisibleNames(
                      'evaluations2.test',
                      false,
                      'Instrumento'
                    ),
                    entity3: $getVisibleNames(
                      'evaluations2.rubric',
                      false,
                      'Pauta'
                    ),
                  })
                : $t('matterProgram.matterProgramView.evaluationHasNoContent', {
                    entity1: $getVisibleNames(
                      'evaluations2.evaluation',
                      false,
                      'Evaluación'
                    ),
                    entity2: $getVisibleNames(
                      'evaluations2.test',
                      false,
                      'Instrumento'
                    ),
                    entity3: $getVisibleNames(
                      'evaluations2.rubric',
                      false,
                      'Pauta'
                    ),
                  })
            "
          >
            {{
              evaluationStatus(evaluation).has_content
                ? $t("reusable.common.yes")
                : $t("reusable.common.no")
            }}
          </b-badge>
          <span v-else>{{ $t("reusable.common.notApplicable") }}</span>
        </b-td>

        <b-td
          class="print-horas"
          v-if="
            institution &&
            institution.internal_use_id != 'dionisioromerouniversity.com'
          "
        >
          <div
            v-for="(study_environment, index) in getMatterTimeAllocation(
              evaluation.id,
              true
            )"
            :key="'evaluation' + evaluation.id + 'index' + index"
          >
            <div>
              <strong>{{ study_environment.name }}</strong>
            </div>
            <div
              v-for="(time_allocation, index2) in study_environment.time_hours"
              :key="
                'evaluation' +
                evaluation.id +
                'index' +
                index +
                'index2' +
                index2
              "
            >
              <div class="ml-3">
                {{ time_allocation.name }}
                <b
                  >{{ time_allocation.hours }}
                  {{ $t("matterProgram.matterProgramView.hrs") }}</b
                >
              </div>
            </div>
          </div>
        </b-td>
        <b-td
          v-if="!$hidesAutonomousWorkHours(institution)"
          class="print-horas"
        >
          <div
            v-for="(study_environment, index) in getMatterTimeAllocation(
              evaluation.id,
              false
            )"
            :key="'evaluation' + evaluation.id + 'index' + index"
          >
            <div>
              <strong>{{ study_environment.name }}</strong>
            </div>
            <div
              v-for="(time_allocation, index2) in study_environment.time_hours"
              :key="
                '-evaluation' +
                evaluation.id +
                '-index' +
                index +
                '-index2' +
                index2
              "
            >
              <div class="ml-3">
                {{ time_allocation.name }}
                <b
                  >{{ time_allocation.hours }}
                  {{ $t("matterProgram.matterProgramView.hrs") }}</b
                >
              </div>
            </div>
          </div>
        </b-td>
        <b-td
          v-if="
            institution &&
            institution.show_evaluation_criteria_macro &&
            canViewEvaluations
          "
          :class="
            evaluation.evaluation_criterias_macro.length > 0
              ? 'text-justify print-criterios'
              : 'text-center print-criterios'
          "
        >
          <template v-if="evaluation.evaluation_criterias_macro.length > 0">
            <template
              v-for="evaluation_criteria in evaluationCriteriasMacrosFilter"
            >
              <span
                :key="evaluation_criteria.id"
                v-if="
                  evaluation.evaluation_criterias_macro.includes(
                    evaluation_criteria.id
                  )
                "
              >
                <span style="position: absolute">
                  {{ evaluation_criteria.order }}
                </span>
                <SentenceContainer
                  style="padding-left: 5px; padding-top: 2px"
                  :Sentence="evaluation_criteria"
                  :boundedTextContainer="false"
                ></SentenceContainer>
              </span>
            </template>
          </template>
          <template v-else>
            {{ $t("reusable.common.notApplicable") }}
          </template>
        </b-td>
        <b-td
          v-if="canViewEvaluations"
          :class="
            evaluationCriteriasMicros.filter((x) =>
              evaluation.evaluation_criterias_micro.includes(x.id)
            ).length > 0
              ? 'text-justify print-criterios criterios-micro-column'
              : 'text-center print-criterios criterios-micro-column'
          "
        >
          <template
            v-if="
              evaluationCriteriasMicros.filter((x) =>
                evaluation.evaluation_criterias_micro.includes(x.id)
              ).length > 0
            "
          >
            <template v-for="study_unit in filterECMicro">
              <div
                :key="study_unit.id"
                :class="{
                  'evaluation-criteria-container':
                    institution && institution.internal_use_id == 'duoc.cl',
                }"
              >
                <strong
                  class="mr-2"
                  :key="study_unit.id"
                  v-if="
                    study_unit.options.filter((x) =>
                      evaluation.evaluation_criterias_micro.includes(x.id)
                    ).length > 0
                  "
                  >{{ study_unit.name }}
                </strong>
                <div
                  class="ec-badge-container"
                  :key="'ec-container' + study_unit.id"
                >
                  <div
                    v-for="evaluation_criteria in study_unit.options"
                    :key="study_unit.id + ':' + evaluation_criteria.id"
                  >
                    <div
                      v-if="
                        evaluation.evaluation_criterias_micro.includes(
                          evaluation_criteria.id
                        )
                      "
                      :key="
                        'div' + study_unit.id + ':' + evaluation_criteria.id
                      "
                      class="text-center"
                    >
                      <b-badge
                        :id="`ec-badge-${evaluation.id}-${study_unit.id}-${evaluation_criteria.id}`"
                        class="ec-micro-badge"
                        :class="{
                          'ec-micro-badge-in-use':
                            show_evaluation_content &&
                            evaluationStatus(evaluation).applies &&
                            isECMicroInUse(evaluation, evaluation_criteria.id),
                          'ec-micro-badge-not-in-use':
                            show_evaluation_content &&
                            evaluationStatus(evaluation).applies &&
                            !isECMicroInUse(evaluation, evaluation_criteria.id),
                        }"
                        v-b-tooltip.v-secondary.noninteractive.html="
                          ecMicroBadgeTooltip(evaluation, evaluation_criteria)
                        "
                      >
                        {{
                          study_unit.competence_unit_order != 999
                            ? study_unit.competence_unit_order + "."
                            : ""
                        }}{{ study_unit.order }}.{{ evaluation_criteria.order }}
                      </b-badge>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
          <template v-else
            ><span> {{ $t("reusable.common.notApplicable") }} </span>
          </template>
        </b-td>
        <b-td class="td-btn-wrapper" v-if="allows_crud">
          <ButtonWrapper :item_id="evaluation.id">
            <template v-slot:btn-slot>
              <b-button
                v-if="allows_crud && can_update"
                size="sm"
                fill="white"
                variant="none"
                v-b-tooltip.v-secondary.noninteractive.top="
                  $t(
                    'matterProgram.matterProgramView.editBibliographicResources'
                  )
                "
                @click="
                  $bvModal.show(
                    `m-bibliographic-resource-modal-${evaluation.id}`
                  )
                "
              >
                <b-icon icon="book"></b-icon>
              </b-button>
              <ButtonSmall
                v-if="allows_crud && can_update"
                :tooltip_text="
                  $t('matterProgram.matterProgramView.editActivityEvaluation')
                "
                :click_button="
                  () =>
                    $bvModal.show(
                      `edit-matter-evaluation-modal-${evaluation.id}`
                    )
                "
                :class="``"
                :icon="'square'"
              ></ButtonSmall>
              <ButtonSmall
                v-if="can_delete && allows_crud"
                :click_button="
                  () => deleteEvaluation(evaluation.id, evaluation.type)
                "
                :tooltip_text="
                  $t('matterProgram.matterProgramView.deleteActivityEvaluation')
                "
                :icon="'trash'"
              ></ButtonSmall>
            </template>
          </ButtonWrapper>
          <b-modal
            :id="`m-bibliographic-resource-modal-${evaluation.id}`"
            :title="
              $t('matterProgram.matterProgramView.editBibliographicResources')
            "
            size="xl"
            hide-footer
          >
            <MEvaluationBibliographicResource
              :m_evaluation_id="evaluation.id"
              :matter_id="matter_id"
              :allows_crud="allows_crud"
              :can_delete="can_delete"
              :can_update="can_update"
            ></MEvaluationBibliographicResource>
          </b-modal>
          <b-modal
            :id="`edit-matter-evaluation-modal-${evaluation.id}`"
            :title="
              $t('matterProgram.matterProgramView.editActivityEvaluation')
            "
            size="xl"
            hide-footer
          >
            <MatterProgramEvaluationForm
              :matter_id="matter_id"
              :Evaluation="evaluation"
              :EvaluationSituations="evaluation_situations"
              :evaluation_list="filterMatterEvaluations"
              :EvaluativeAgentTypes="evaluative_agent_types"
              :MatEvaStuEnvTimAll="mat_eva_stu_env_tim_all"
              @updated="updatedEvaluation"
              @created_support_resource="createdSupportResource"
            >
            </MatterProgramEvaluationForm>
          </b-modal>
        </b-td>
      </b-tr>
    </template>
    <b-tr v-else>
      <b-td class="text-center" :colspan="show_evaluation_content ? 10 : 9">{{
        $t("matterProgram.matterProgramView.noActivitiesOrEvaluationsToShow")
      }}</b-td>
    </b-tr>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { activityEvaluationType } from "@/utils/instructional_activity_types";
export default {
  name: "MatterProgramEvaluationDraggable",
  components: {
    draggable,
    MatterProgramEvaluationForm: () =>
      import("./MatterProgramEvaluationForm.vue"),
    MEvaluationBibliographicResource: () =>
      import("./MEvaluationBibliographicResource.vue"),
    SentenceContainer: () => import("@/components/reusable/SentenceContainer"),
    ButtonWrapper: () => import("@/components/reusable/ButtonWrapper"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    // { [evaluation_id]: { applies, has_content, used_ecm_ids } }
    EvaluationsStatus: {
      type: Object,
      default() {
        return {};
      },
    },
    show_evaluation_content: {
      type: Boolean,
      default: false,
    },
    allows_crud: {
      type: Boolean,
    },
    matter_id: {
      type: Number,
      required: true,
    },
    // Destino del salto al Diseno Instruccional: la ruta del DI se ancla en la
    // Asignatura del Perfil de Egreso, no en la Asignatura base.
    egress_profile_matter_id: {
      type: Number,
      default: null,
    },
    learning_experience: {
      type: [Number, null],
      default: null,
    },
    EvaluationSituations: {
      type: Array,
    },
    EvaluativeAgentTypes: {
      type: Array,
    },
    MatEvaStuEnvTimAll: {
      type: Array,
    },
    include_transversal_evaluation: {
      type: Boolean,
      default: false,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      evaluation_situations: this.EvaluationSituations,
      evaluative_agent_types: this.EvaluativeAgentTypes,
      mat_eva_stu_env_tim_all: this.MatEvaStuEnvTimAll,
    };
  },
  computed: {
    canRedirectToEvaluation() {
      // Requerimiento UDALBA: ADMINISTRATIVOS INSTRUCCIONALES no edita el
      // programa de la asignatura (can_update = false), pero sí debe poder
      // entrar a NewEvaluation para editar su contenido.
      return (
        this.can_update ||
        (this.institution &&
          this.institution.internal_use_id == "udalba.cl" &&
          this.user &&
          this.user.group_names.includes("ADMINISTRATIVOS INSTRUCCIONALES"))
      );
    },
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      studyEnvironments: names.STUDY_ENVIRONMENTS,
      time_allocations: names.TIME_ALLOCATIONS,
      matter_time_allocations: names.MATTER_TIME_ALLOCATIONS,
      evaluationCriteriasMacros: names.EVALUATION_CRITERIAS_MACROS,
      evaluationCriteriasMicros: names.EVALUATION_CRITERIAS,
      studyUnits: names.STUDY_UNITS,
      matterEvaluations: names.MATTER_EVALUATIONS,
      epm_evaluation_types: names.EPM_EVALUATION_TYPES,
      competence_units: names.COMPETENCE_UNITS,
      new_tests: names.NEW_TESTS,
      work_types: names.TEST_WORK_TYPES,
    }),
    canViewEvaluations() {
      if (!this.user || !this.user.group_names) return false;
      return !(
        this.user.group_names.includes("PROFESORES") ||
        this.user.group_names.includes("ESTUDIANTES")
      );
    },
    filterMatterEvaluations() {
      if (!this.matter_id) return [];
      return this.matterEvaluations
        .filter((x) => x.matter == this.matter_id)
        .sort((a, b) => a.order - b.order);
    },
    draggableList: {
      get() {
        let list = [];
        if (this.include_transversal_evaluation)
          list = this.filterMatterEvaluations.filter(
            (x) =>
              x.learning_experience == this.learning_experience && x.type == 5
          );
        else
          list = this.filterMatterEvaluations.filter(
            (x) =>
              x.learning_experience == this.learning_experience && x.type != 5
          );
        list.sort(function (a, b) {
          if (a.order < b.order) return -1;
          if (a.order > b.order) return 1;
          return 0;
        });
        let order = 1;
        list.forEach((element) => {
          if (element.order != order) element.order = order;
          order += 1;
        });
        return list;
      },
      set(list) {
        let order = 1;
        list.forEach((element) => {
          if (element.order != order) {
            element.order = order;
            if (!isNaN(element.id)) {
              this.patchEvaluationOrder(element);
            }
          }
          order += 1;
        });
      },
    },
    evaluationCriteriasMacrosFilter() {
      return this.evaluationCriteriasMacros
        .filter((x) => x.matter == this.matter_id)
        .sort(function (a, b) {
          if (a.matter > b.matter) return 1;
          if (a.matter < b.matter) return -1;
          if (a.order > b.order) return 1;
          if (a.order < b.order) return -1;
          return 0;
        });
    },
    studyUnitsList() {
      if (!this.matter_id) return [];
      return this.studyUnits
        .filter((x) => x.matter == this.matter_id)
        .sort(function (a, b) {
          if (a.order > b.order) return 1;
          if (a.order < b.order) return -1;
          return 0;
        });
    },
    filterECMicro() {
      let list = [];
      this.studyUnitsList.forEach((study_unit) => {
        const evaluation_criterias = this.evaluationCriteriasMicros.filter(
          (x) => x.study_unit == study_unit.id
        );
        const competence_unit = this.competence_units.find(
          (c) => c.id == study_unit.temp_competence_unit
        );
        if (evaluation_criterias.length > 0)
          list.push({
            id: study_unit.id,
            name: String(
              "N°" +
                (competence_unit ? competence_unit.order + "." : "") +
                study_unit.order +
                ": " +
                study_unit.name
            ),
            order: study_unit.order,
            competence_unit_order: competence_unit
              ? competence_unit.order
              : 999,
            options: this.evaluationCriteriasMicros
              .filter((x) => x.study_unit == study_unit.id)
              .sort(function (a, b) {
                if (a.order > b.order) return 1;
                if (a.order < b.order) return -1;
                return a.full_sentence
                  .toLowerCase()
                  .localeCompare(b.full_sentence.toLowerCase());
              }),
          });
      });
      return list.sort(function (a, b) {
        if (a.competence_unit_order > b.competence_unit_order) return 1;
        if (a.competence_unit_order < b.competence_unit_order) return -1;
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        return 0;
      });
    },
  },
  methods: {
    evaluationStatus(evaluation) {
      return (
        this.EvaluationsStatus[evaluation.id] || {
          applies: false,
          has_content: false,
          used_ecm_ids: [],
        }
      );
    },
    // Un Criterio de Evaluación Micro asignado a la evaluación se considera en
    // uso cuando aparece en alguna pregunta o dimensión de pauta de sus
    // instrumentos.
    isECMicroInUse(evaluation, evaluation_criteria_micro_id) {
      return this.evaluationStatus(evaluation).used_ecm_ids.includes(
        evaluation_criteria_micro_id
      );
    },
    ecMicroBadgeTooltip(evaluation, evaluation_criteria_micro) {
      const tooltip = `${evaluation_criteria_micro.full_sentence}`;
      if (
        !this.show_evaluation_content ||
        !this.evaluationStatus(evaluation).applies
      )
        return tooltip;
      return `${tooltip}<br><i>${
        this.isECMicroInUse(evaluation, evaluation_criteria_micro.id)
          ? this.$t("matterProgram.matterProgramView.ecMicroInUse")
          : this.$t("matterProgram.matterProgramView.ecMicroNotInUse")
      }</i>`;
    },
    getWorkType(id) {
      return this.work_types.find((x) => x.id == id)?.value;
    },
    getMatterTimeAllocation(matter_evaluation_id, is_pedagogical_hours) {
      const time_allocation_ids_is_pedagogical = this.time_allocations
        .filter((x) => x.uses_module_minutes == is_pedagogical_hours)
        .map((x) => x.id);
      const mat_eva_stu_env_time_all = this.MatEvaStuEnvTimAll.filter(
        (x) =>
          x.matter_evaluation == matter_evaluation_id &&
          time_allocation_ids_is_pedagogical.includes(x.time_allocation) &&
          x.hours > 0
      );
      if (mat_eva_stu_env_time_all.length > 0) {
        let list = [];
        const study_environments_ids = [
          ...new Set(mat_eva_stu_env_time_all.map((x) => x.study_environment)),
        ];
        this.studyEnvironments
          .filter((x) => study_environments_ids.includes(x.id))
          .forEach((study_environment) => {
            list.push({
              name: study_environment.name,
              time_hours: mat_eva_stu_env_time_all
                .filter((x) => x.study_environment == study_environment.id)
                .map((x) => ({
                  name:
                    (
                      this.time_allocations.find(
                        (time) => time.id == x.time_allocation
                      ) || {}
                    ).name || "",
                  hours: x.hours,
                })),
            });
          });
        if (study_environments_ids.includes(null)) {
          list.push({
            name:
              this.$t("matterProgram.matterProgramView.without2") +
              " " +
              this.$getVisibleNames(
                "mesh.studyenvironment",
                false,
                "Ambiente de Aprendizaje"
              ) +
              ":",
            time_hours: mat_eva_stu_env_time_all
              .filter((x) => x.study_environment == null)
              .map((x) => ({
                name:
                  (
                    this.time_allocations.find(
                      (time) => time.id == x.time_allocation
                    ) || {}
                  ).name || "",
                hours: x.hours,
              })),
          });
        }
        return list;
      } else return [];
    },
    filterTestsByEvaluation(evaluation_id) {
      return this.new_tests.filter((x) => x.evaluation == evaluation_id);
    },
    createdSupportResource(response) {
      this.$emit("created_support_resource", response);
    },
    redirectToEvaluation(evaluation_id, instrument_id = null) {
      this.$router.push({
        name: "NewEvaluationView",
        params: {
          evaluation_id: evaluation_id,
          instrument_id: instrument_id,
        },
      });
    },
    // La fila representa una Actividad del Diseno Instruccional.
    //
    // E37 · Antes preguntaba ademas por `evaluation.instructional_activity`, el id de la ficha
    // que el serializer exponia. Esa ficha ya no existe: la Actividad ES esta misma fila, y lo
    // que la distingue es lo que el comentario de E24 ya decia — "es una Actividad" quiere
    // decir tipo 4, y nada mas.
    isInstructionalActivity(evaluation) {
      return evaluation.type == 4;
    },
    // Una Actividad se administra en el DI, no en evaluations2: ahi estan sus
    // horas, su momento, sus IL y la semana en la que cae. Si la institucion no
    // tiene el modulo, la fila se comporta como cualquier otra evaluacion.
    goesToInstructionalDesign(evaluation) {
      return !!(
        this.isInstructionalActivity(evaluation) &&
        this.institution &&
        this.institution.kl_instructional_design &&
        this.egress_profile_matter_id
      );
    },
    // El nombre es un enlace si el usuario puede entrar al destino. El destino
    // manda: el DI no depende de kl_assessment, que es lo que habilita
    // evaluations2.
    canOpenRow(evaluation) {
      if (!this.canRedirectToEvaluation || !this.user) return false;
      const is_staff =
        (!this.user.group_names.includes("PROFESORES") &&
          !this.user.group_names.includes("ESTUDIANTES")) ||
        this.user.is_superuser;
      if (!is_staff) return false;
      if (this.goesToInstructionalDesign(evaluation)) return true;
      return !!(
        evaluation.evaluation != null &&
        this.institution &&
        this.institution.kl_assessment
      );
    },
    openRow(evaluation) {
      if (this.goesToInstructionalDesign(evaluation))
        this.redirectToInstructionalDesign(evaluation.id);
      else this.redirectToEvaluation(evaluation.evaluation);
    },
    // `activity` en la query para que el DI abra su Unidad y haga scroll hasta la tarjeta:
    // sin eso el usuario cae en la vista colapsada y tiene que buscarla a mano.
    // E37 · El id que viaja es el de la evaluacion, que es la misma fila que el DI muestra.
    redirectToInstructionalDesign(instructional_activity_id) {
      this.$router.push({
        name: "InstructionalView",
        params: { matter_id: this.egress_profile_matter_id },
        query: { activity: instructional_activity_id },
      });
    },
    createdNewEvaluation(response, tests_list) {
      this.$store
        .dispatch(names.POST_NEW_EVALUATION, {
          title: response.name,
          description: response.description,
          weighing: response.weighing,
          visible_by_evaluatees: false,
          parent_evaluation: null,
          files: [],
        })
        .then((new_evaluation) => {
          this.$store.commit(
            "MUTATE_CHANGE_NEW_EVALUATION_BY_MATTER_EVALUATION",
            {
              new_evaluation_id: new_evaluation.id,
              matter_evaluation_id: response.id,
            }
          );
          this.$restful
            .Post("/evaluations2/evaluation-scope-default/", {
              scope: 3,
              scope_id: this.matter_id,
              evaluation: new_evaluation.id,
            })
            .then((evaluation_scope) => {
              this.$store.commit(
                "MUTATE_CHANGE_NEW_EVALUATION_SCOPE_BY_NEW_EVALUATION",
                evaluation_scope
              );
              response.evaluation = new_evaluation.id;
              this.$store
                .dispatch(names.PATCH_MATTER_EVALUATION, {
                  matter_evaluation_id: response.id,
                  item: { evaluation: new_evaluation.id },
                })
                .then(() => {
                  this.bulkCreateTest(tests_list, new_evaluation);
                });

              // evaluation_type:  diagnóstica 1, formativa 2, sumativa 3, actividad 4, transversal 5
              // evaluations2: sumativa 1, diagnóstica 2, formativa 3, trasnversal 4
              let evaluation_type = null;
              // diagnóstica 1 => diagnóstica 2
              if (response.type == 1) evaluation_type = 2;
              // formativa 2 => formativa 3
              else if (response.type == 2) evaluation_type = 3;
              // actividad 4: el tipo visible es "Actividad" y Formativa/Sumativa
              // es su subtipo, que se deduce de si pondera. Mismo criterio que
              // el "¿Posee Ponderación?" del Diseño Instruccional.
              else if (response.type == 4)
                evaluation_type = activityEvaluationType(response.weighing);
              // sumativa 3 => sumativa 1
              else if (response.type == 3) evaluation_type = 1;
              // trasnversal 5 => trasnversal 4
              else if (response.type == 5) evaluation_type = 4;
              // formativa 3
              else evaluation_type = 3;
              this.saveEvaluationTypeDefault(new_evaluation, {
                id: new_evaluation.evaluation_type_default,
                type: evaluation_type,
                evaluation: new_evaluation.id,
              });
              if (
                this.filterMatterEvaluations.find((x) => x.id == response.id)
              ) {
                this.$bvModal.hide(
                  `edit-matter-evaluation-modal-${response.id}`
                );
              }
            });
        });
    },
    saveEvaluationTypeDefault(new_evaluation, evaluation_type) {
      if (evaluation_type) {
        if (new_evaluation.evaluation_type_default == null) {
          this.$restful
            .Post("/evaluations2/evaluation-type-default/", evaluation_type)
            .then((response) => {
              this.$store.commit(
                "MUTATE_CHANGE_NEW_EVALUATION_TYPE_BY_NEW_EVALUATION",
                response
              );
            });
        } else {
          this.$restful
            .Put(
              `/evaluations2/evaluation-type-default/${evaluation_type.id}/`,
              evaluation_type
            )
            .then((response) => {
              this.$store.commit(
                "MUTATE_CHANGE_NEW_EVALUATION_TYPE_BY_NEW_EVALUATION",
                response
              );
            });
        }
      }
    },
    async bulkCreateTest(test_list, new_evaluation) {
      for await (let test of test_list) {
        if (isNaN(test.id)) {
          test.evaluation = new_evaluation.id;
          if (this.institution && this.institution.internal_use_id == "duoc.cl")
            test.title = new_evaluation.title;
          await this.$store
            .dispatch(names.POST_NEW_TEST, test)
            .then((new_test) => {
              this.saveTestType({
                ...new_test,
                instrument_type: test.instrument_type,
              });
            });
        } else if (!test.delete_test) {
          await this.$store
            .dispatch(names.PATCH_NEW_TEST, {
              new_test_id: test.id,
              item: {
                title: test.title,
                evaluation_situation: test.evaluation_situation,
                weighing: test.weighing,
                examiner: test.examiner,
                work_type: test.work_type,
                authentic_evaluation: test.authentic_evaluation,
              },
            })
            .then((new_test) => {
              this.saveTestType({
                ...new_test,
                instrument_type: test.instrument_type,
              });
            });
        } else if (test.delete_test) {
          await this.$store.dispatch(names.DELETE_NEW_TEST, test.id);
        }
      }
    },
    saveTestType(new_test) {
      if (new_test.test_type_default == null) {
        this.$restful
          .Post("/evaluations2/test-type-default/", {
            test: new_test.id,
            evaluative_agent: new_test.instrument_type.evaluative_agent,
          })
          .then((response) => {
            this.$store.commit(
              "MUTATE_CHANGE_NEW_TEST_TYPES_BY_NEW_TEST",
              response
            );
          });
      } else {
        this.$restful
          .Put(
            `/evaluations2/test-type-default/${new_test.test_type_default}/`,
            {
              test: new_test.id,
              evaluative_agent: new_test.instrument_type.evaluative_agent,
            }
          )
          .then((response) => {
            this.$store.commit(
              "MUTATE_CHANGE_NEW_TEST_TYPES_BY_NEW_TEST",
              response
            );
          });
      }
    },
    deleteEvaluation(id, type) {
      const evaluation_type = this.epm_evaluation_types.find(
        (x) => x.id == type
      );
      let msg = "";
      if (evaluation_type) {
        if (type == 4)
          msg =
            this.$t("matterProgram.matterProgramView.the") +
            " " +
            evaluation_type.value.toLowerCase();
        else
          msg =
            this.$t("matterProgram.matterProgramView.theEvaluation") +
            " " +
            evaluation_type.value.toLowerCase();
      }
      // Una Actividad y su evaluacion son el mismo objeto: borrarla aca la borra
      // tambien del Diseno Instruccional, con sus instrucciones, contenidos, horas
      // y momento. Se avisa porque el usuario no esta viendo esa vista.
      const row = this.draggableList.find((x) => x.id == id);
      const also_deletes_activity = !!(
        row &&
        this.isInstructionalActivity(row) &&
        this.institution &&
        this.institution.kl_instructional_design
      );
      this.$swal({
        title: this.$t("matterProgram.matterProgramView.confirmDeleteEntity", {
          entity: msg,
        }),
        text: also_deletes_activity
          ? this.$t("teaching.instructional.activityDeleteFromProgramWarning",
            {
              entity: this.$getVisibleNames(
                "manual.instructional_design.activity",
                false,
                "Actividad"
              ),
              evaluation: this.$getVisibleNames(
                "evaluations2.evaluation",
                false,
                "Evaluación"
              ),
            })
          : this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
        cancelButtonText: this.$t("reusable.common.cancel"),
      }).then((result) => {
        if (result.value) {
          const matter_evaluation = this.filterMatterEvaluations.find(
            (x) => x.id == id
          );
          this.$store.dispatch(names.DELETE_MATTER_EVALUATION, id).then(() => {
            // Si era una Actividad, el backend ya borro su Evaluation al borrar el
            // wrapper (pre_delete -> delete_own_evaluation): pedirlo de nuevo solo
            // devolveria un 404.
            if (
              matter_evaluation &&
              matter_evaluation.evaluation != null &&
              !also_deletes_activity
            )
              this.$store.dispatch(
                names.DELETE_NEW_EVALUATION,
                matter_evaluation.evaluation
              );
            this.$emit("fetch_mat_eva_stu_env_tim_all");
          });
        }
      });
    },
    patchEvaluationOrder(evaluation) {
      this.$store.dispatch(names.PATCH_MATTER_EVALUATION, {
        matter_evaluation_id: evaluation.id,
        item: {
          order: evaluation.order,
        },
      });
    },
    updatedEvaluation(evaluation, tests_list) {
      this.$store
        .dispatch(names.UPDATE_MATTER_EVALUATION, evaluation)
        .then((response) => {
          // Igual que al crear: el tipo "Actividad" tambien necesita su Evaluation.
          // Editar una Actividad vieja, creada cuando el tipo 4 se lo saltaba, se
          // la crea ahora.
          if (response.evaluation == null) {
            this.createdNewEvaluation(response, tests_list);
          } else {
            if (response.evaluation != null) {
              this.$store
                .dispatch(names.PATCH_NEW_EVALUATION, {
                  new_evaluation_id: response.evaluation,
                  item: {
                    title: response.name,
                    description: response.description,
                    weighing: response.weighing,
                  },
                })
                .then((new_evaluation) => {
                  this.$store.commit(
                    names.MUTATE_NEW_EVALUATION,
                    new_evaluation
                  );
                  this.$store
                    .dispatch(names.FETCH_NEW_TESTS, {
                      evaluation_id: new_evaluation.id,
                    })
                    .then((tests) => {
                      this.validTests(tests);
                    });
                  this.bulkCreateTest(tests_list, new_evaluation);
                });
            }
            this.$bvModal.hide(`edit-matter-evaluation-modal-${response.id}`);
          }
        });
    },
    async validTests(tests) {
      for await (let test of tests.filter(
        (x) => x.manual_is_valid === true && x.is_valid[0] === false
      )) {
        await this.$store.dispatch(names.PATCH_NEW_TEST, {
          new_test_id: test.id,
          item: { manual_is_valid: false },
        });
      }
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.td-btn-wrapper {
  text-align: -webkit-center;
}
.evaluation-criteria-container {
  display: flex;
  margin-left: 0.25rem !important;
}
.description-evaluation {
  justify-self: center;
  max-height: 200px;
  overflow-y: auto;
  max-width: 100%;
}
.div-href {
  color: #007bff;
}
.div-href:hover {
  color: #0057b1 !important;
  text-decoration: underline;
  cursor: pointer;
}
table th {
  vertical-align: middle;
  background-color: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
  font-size: var(--primary-font-size);
  padding: 2px 2px;
}
.evaluation-header {
  background: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary);
  border: 1px solid var(--kl-table-border) !important;
}
.evaluation-button-div {
  float: right;
  /* padding-right: 1rem; */
}
table td {
  border: 1px solid var(--kl-table-border) !important;
  text-align: left;
  vertical-align: middle;
  font-size: var(--secondary-font-size);
  padding: 2px 2px;
}
.grabbable {
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.grabbable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
.ec-badge-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
.ec-micro-badge {
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
  text-align: center;
  width: fit-content !important;
  margin-right: 0.3em;
  /* Badge alineado al estándar de chip suave (celeste + texto azul). */
  background: var(--kl-chip-bg);
  color: var(--kl-chip-text);
  border: 1px solid var(--kl-chip-border);
  border-radius: var(--kl-radius-pill);
}
/* Criterio de Evaluación Micro efectivamente utilizado en alguna pregunta o
   dimensión de pauta de los instrumentos de la evaluación. */
.ec-micro-badge-in-use {
  background: var(--kl-color-success);
  color: var(--kl-text-on-primary);
  border-color: var(--kl-color-success);
}
/* Asignado a la evaluación, pero sin uso en su contenido. */
.ec-micro-badge-not-in-use {
  background: var(--kl-color-danger);
  color: var(--kl-text-on-primary);
  border-color: var(--kl-color-danger);
}
.criterios-micro-column {
  min-width: 100px;
  max-width: 250px;
  overflow-wrap: break-word;
}
@media print {
  .ec-micro-badge {
    border: none;
  }

  /* Clases específicas para impresión */
  /* .print-nombre {
    width: 120px !important;
  }
  .print-instrumento {
    width: 100px !important;
  }
  .print-descripcion {
    width: auto !important;
    min-width: 200px !important;
  }
  .print-tipo {
    width: 60px !important;
  }
  .print-ponderacion {
    width: 80px !important;
  }
  .print-horas {
    width: 120px !important;
  }
  .print-criterios {
    width: 100px !important;
  } */

  /* Ajustar contenido de descripción */
  .description-evaluation {
    overflow: visible !important;
    max-height: none !important;
    word-wrap: break-word !important;
  }

  /* Ajustar tablas dentro de descripción */
  .description-evaluation table {
    width: 100% !important;
    table-layout: fixed !important;
    font-size: 10px !important;
  }

  .description-evaluation table td,
  .description-evaluation table th {
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    hyphens: auto !important;
    padding: 2px !important;
  }
}
</style>